// export default EmiDueReport;
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Trash } from "lucide-react";
import "../assets/GroupMember.css";

const GroupMember = () => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [formData,setFormData]=useState({groupType:"",memberName:""});
  const [memberData,setMemberData]=useState([])

  // 🔍 Search + Pagination
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmit=(e)=>{
  e.preventDefault();
  setMemberData((prev) => [...prev, formData]);
  // alert("Member Added")
  //  console.log(memberData)
  //  setFormData({groupType:"",memberName:""})
}

  // Static data
  const staticData = [
    {
      groupType: "Group A",
      groupName: "Group",
    },
  ];

  // search and filter logic
  const filteredData = useMemo(() => {
    let data = [...memberData];

    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    return data;
  }, [searchQuery,memberData]);

  // pagination
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="group-member-container">
      <h1 className="group-member-heading">Group Member</h1>

      {/* Group Member Creation section */}
      <div className="group-member-create-container">
        <h2>Create Group Member</h2>
        <form className="group-member-create-form" onSubmit={handleSubmit}>
          {/* <div className="group-member-create-form-groups"></div> */}
          <select name="groupType" id="group-type" value={formData.groupType} onChange={handleChange}>
            <option value="Select Group Type">Select Group Type</option>
            <option value="Group A">Group A</option>
            <option value="Group B">Group B</option>
            <option value="Group C">Group C</option>
          </select>
          <input type="text" name="memberName" placeholder="Member Name" value={formData.memberName} onChange={handleChange} />
          <button>Add</button>
        </form>
      </div>

      {/* Group member report section */}
      <div className="group-member-report-container">
        <h2>Group Member Report</h2>
        <div className="group-member-report-filter">
          <input
            type="text"
            placeholder="Search by any field..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
          />

          <label>
            Show{" "}
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>{" "}
            entries
          </label>
        </div>

        {/* Search input */}
        {/* <div className="DDFDReportsearch-box">
        <input
          type="text"
          placeholder="Search by any field..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div> */}

        {/* Table */}
        <div className="group-member-report-section">
          <table className="group-member-report-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Group Type</th>
                <th>Member Name</th>
                {/* <th>Group Name</th>
              <th>Description</th>
              <th>DGT Start Date</th>
              <th>CGT Taken By</th> */}
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((mdata, i) => (
                  <tr key={i}>
                    <td>{(currentPage - 1) * rowsPerPage + i + 1}</td>
                    <td>{mdata.groupType}</td>
                    <td>{mdata.memberName}</td>
                    <td className="group-member-report-btns">
                      <button
                        className="group-member-report-edit-btn"
                        // onClick={() => {
                        //   setIsModalOpen(true);
                        //   setSelectedCustomer(row);
                        // }}
                        title="Edit" // tooltip on hover
                      >
                        <Edit />
                      </button>

                      <button
                        className="group-member-report-delete-btn"
                        // onClick={() => openDeleteDialog(row.id)}
                        title="Delete"
                      >
                        <Trash />
                      </button>
                    </td>
                  </tr>
                ))): (
            <tr>
              <td
                    colSpan="10"
                    className="group-member-report-table-no-records"
                  >
                    ✅ No records found
                  </td>
            </tr>
          )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      <div className="group-member-report-pagination-btns">
        <button
          onClick={() => setCurrentPage((p) => p - 1)}
          disabled={currentPage === 1}
        >
          ⬅ Previous
        </button>

        <span>
          Page {currentPage} of {totalPages || 1}
        </span>

        <button
          onClick={() => setCurrentPage((p) => p + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default GroupMember;
